
export default function formatDuration(duration) {
  const totalSeconds = Number(duration);
  if (isNaN(totalSeconds) || totalSeconds < 0) return '-';
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return secs === 0 ? `${mins}m` : `${mins}m ${secs}s`;
}
